import { useEffect } from 'react';
import { useCustomerNotifications } from '../../context/CustomerNotificationsContext';
import { useSupportChat } from '../../context/SupportChatContext';

const CustomerOpenChatReadSync = () => {
  const { isOpen, conversationId } = useSupportChat();
  const { acknowledgeChat } = useCustomerNotifications();

  useEffect(() => {
    if (!isOpen || !conversationId) {
      acknowledgeChat(null);
      return undefined;
    }
    acknowledgeChat(conversationId);
    return () => {
      acknowledgeChat(null);
    };
  }, [isOpen, conversationId, acknowledgeChat]);

  return null;
};

export default CustomerOpenChatReadSync;
